// React imports
import React, { useState, useMemo } from 'react';

// Generic imports
import _ from 'lodash';
import prettyBytes from 'pretty-bytes';

// MUI imports
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// FontAwesome imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/pro-light-svg-icons';

// Local imports
import email from '../utils/email';

function AttachmentWarning(props) {
    const {
        open,
        conversationId,
        conversations,
        onClose,
        onCreateOpportunity,
        org,
        tokens,
        accesstoken,
    } = props;

    const [download, setDownload] = useState(false);
    const [working, setWorking] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const conversation = useMemo(() => {
        if (!open) return null;
        return conversations.find(c => c[0].conversationId === conversationId);
    }, [open, conversations, conversationId]);

    const totalBytes = useMemo(() => {
        if (!conversation) return 0;
        return _.sumBy(conversation.map(message => message.attachments).flat(), 'size') || 0;
    }, [conversation]);

    async function downloadAttachments() {
        setWorking(true);
        setError(null);
        setSuccess(null);
        try {
            const attachments = conversation.map(message => message.attachments).flat();
            console.log('[EmailPage] attachments', attachments);
            const urls = [];
            for (let i = 0; i < attachments.length; i++) {
                const attachment = attachments[i];
                const message = conversation.find(m => !!m?.attachments?.find(a => a.id === attachment.id));
                console.log('[EmailPage] message', message);
                const url = await email.getAttachmentUrl({ org, monadaAccesstoken: accesstoken, tokens, messageId: message.id, attachment: attachment });
                urls.push({ url, name: attachment.name });
            }
            setWorking(false);
            onCreateOpportunity({ conversationId, attachments: urls, force: true });
            onClose();
        } catch (e) {
            setWorking(false);
            setError(e.message);
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle>
                <FontAwesomeIcon icon={faPaperclip} />&nbsp;Attachments found
            </DialogTitle>
            <DialogContent>
                Email contains attachments totaling {prettyBytes(totalBytes)}.
                <br />
                <FormControlLabel
                    sx={{ mt: 2 }}
                    control={<Checkbox checked={download} onChange={e => setDownload(e.target.checked)} />}
                    label="Import Attachments"
                />
                <br />
                {error && <Alert sx={{ mt: 5 }} severity='error'>{error}</Alert>}
                {success && <Alert severity='success'>Attachments imported successfully</Alert>}
            </DialogContent>
            <DialogActions>
                <Button
                    size='small'
                    color='inherit'
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <Button
                    size='small'
                    color='monada-button'
                    variant='contained'
                    disabled={working}
                    onClick={() => {
                        if (download) {
                            downloadAttachments();
                        } else {
                            onCreateOpportunity({ conversationId, force: true });
                            onClose();
                        }
                    }}
                >
                    {working ? <CircularProgress size={18} /> : `Generate${!download ? ' without attachments' : ''}`}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AttachmentWarning;